import React from 'react';
import {Button, Result} from 'antd';
import {Link} from "react-router-dom";

function ErrorPage(props) {
    const info = props.location.state ? props.location.state : {
        status: '404',
        message: '頁面不存在',
        path: '',
        button: ''
    }
    return (
        <Result
            status={info.status}
            title={info.status}
            subTitle={info.message}
            extra={ info.path && (<Button type="primary"><Link to={info.path}>{info.button}</Link></Button>)}
        />
    );
}

export default ErrorPage;
